export function getResponseStatus(error) {
    return error?.response?.status ?? null;
}

export function isUnauthorized(error) {
    return getResponseStatus(error) === 401;
}
